import {

    CORE_LOAD_EVENT_ROOM_FORMAT_REQUEST,
    CORE_LOAD_EVENT_ROOM_FORMAT_SUCCESS,

    CORE_LOAD_EVENT_ROOM_FORMAT_INFO_REQUEST,
    CORE_LOAD_EVENT_ROOM_FORMAT_INFO_SUCCESS,

} from '../../types'

const initialState = []
export default {
    eventRoomFormat: (state = initialState, action) => {
        switch (action.type) {
            case CORE_LOAD_EVENT_ROOM_FORMAT_REQUEST:
                return initialState

            case CORE_LOAD_EVENT_ROOM_FORMAT_SUCCESS:
                return action.payload

            default:
                return state
        }
    },
    eventRoomFormatInfo: (state = initialState, action) => {
        switch (action.type) {
            case CORE_LOAD_EVENT_ROOM_FORMAT_INFO_REQUEST:
                return {}

            case CORE_LOAD_EVENT_ROOM_FORMAT_INFO_SUCCESS:
                return action.payload

            default:
                return state
        }
    },
}


// WEBPACK FOOTER //
// ./src/features/roomformat/reducer.js